(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brand-guide')) {
    customElements.define('brand-guide', class extends HTMLElement {
      connectedCallback() {
        if (!navigator.clipboard || !window.isSecureContext) return;
        this.querySelectorAll('[data-copy-color]').forEach(button => { button.hidden = false; });
        this.addEventListener('click', this.copyColor);
      }
      disconnectedCallback() { this.removeEventListener('click', this.copyColor); }
      async copyColor(event) {
        const button = event.target.closest('[data-copy-color]');
        if (!button) return;
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(button.dataset.copyColor);
          status.textContent = `${status.dataset.success} ${button.dataset.copyColor}`;
        } catch {
          status.textContent = status.dataset.error;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-art-carousel')) {
    customElements.define('home-art-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-index]'));
        if (this.slides.length < 2) return;
        this.index = 0;
        this.querySelector('[data-hero-controls]').hidden = false;
        this.querySelector('[data-hero-previous]').addEventListener('click', () => this.go(this.index - 1), options);
        this.querySelector('[data-hero-next]').addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            const left = this.track.getBoundingClientRect().left;
            const distances = this.slides.map(slide => Math.abs(slide.getBoundingClientRect().left - left));
            this.update(distances.indexOf(Math.min(...distances)), true);
          });
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target.closest('[data-hero-slide]'));
          if (index >= 0) this.go(index, true);
        }, options);
        this.update(0, false);
      }
      go(index, immediate = false) {
        const target = (index + this.slides.length) % this.slides.length;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.slides[target].offsetLeft - this.slides[0].offsetLeft, behavior: immediate || reduced ? 'instant' : 'smooth' });
      }
      update(index, announce) {
        const changed = index !== this.index;
        this.index = index;
        this.slides.forEach((slide, i) => { slide.inert = i !== index; });
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (announce && changed) this.querySelector('[data-hero-status]').textContent = this.slides[index].dataset.title;
      }
      disconnectedCallback() {
        this.abort?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('store-navigation')) {
    customElements.define('store-navigation', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-menu-open]');
        if (!this.dialog?.showModal) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.opener.setAttribute('role', 'button');
        this.opener.setAttribute('aria-haspopup', 'dialog');
        this.opener.setAttribute('aria-expanded', 'false');

        const open = (event) => {
          event.preventDefault();
          if (this.dialog.open) return;
          this.previousOverflow = document.documentElement.style.overflow;
          this.previousGutter = document.documentElement.style.scrollbarGutter;
          document.documentElement.style.scrollbarGutter = 'stable';
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
          this.opener.setAttribute('aria-expanded', 'true');
        };

        this.opener.addEventListener('click', open, options);
        this.opener.addEventListener('keydown', (event) => {
          if (event.key === ' ') open(event);
        }, options);
        this.querySelector('[data-menu-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('a')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.restoreScroll();
          this.opener.setAttribute('aria-expanded', 'false');
          this.opener.focus({ preventScroll: true });
        }, options);
      }

      restoreScroll() {
        if (this.previousOverflow === undefined) return;
        document.documentElement.style.overflow = this.previousOverflow;
        document.documentElement.style.scrollbarGutter = this.previousGutter;
        this.previousOverflow = undefined;
      }

      disconnectedCallback() {
        this.events?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-detail')) {
    customElements.define('product-detail', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return
        this.initialized = true
        this.select = this.querySelector('[data-variant-select]')
        this.price = this.querySelector('[data-product-price]')
        this.compare = this.querySelector('[data-product-compare]')
        this.addButton = this.querySelector('[data-add-to-bag]')
        this.gallery = JSON.parse(this.querySelector('[data-gallery-data]').textContent)
        this.fallback = JSON.parse(this.querySelector('[data-gallery-fallback]').textContent).media
        this.image = this.querySelector('.product-gallery__image')
        this.stage = this.querySelector('.product-gallery__stage')
        this.caption = this.querySelector('[data-gallery-caption]')
        this.thumbnails = [...this.querySelectorAll('[data-gallery-index]')]
        this.setupConfigurator()
        this.select?.addEventListener('change', () => this.updateVariant(true))
        this.querySelector('[data-gallery-thumbnails]').addEventListener('click', (event) => {
          const button = event.target.closest('[data-gallery-index]')
          if (button) this.showView(Number(button.dataset.galleryIndex))
        })
        this.updateVariant(false)
      }

      imageUrl(view, width) {
        const url = new URL(view.url, window.location.origin)
        url.searchParams.set('width', Math.min(width, view.width || width))
        return url.href
      }

      setupConfigurator() {
        if (!this.select) return
        const names = JSON.parse(this.querySelector('[data-option-names]').textContent).map(name => name.toLowerCase())
        this.configVariants = [...this.select.options].map(option => {
          const values = JSON.parse(option.dataset.options)
          const source = Object.fromEntries(names.map((name, index) => [name, values[index]]))
          const finish = (source.finish || '').split(' — ')
          return {
            id: option.value,
            available: option.dataset.available === 'true',
            format: source.format || finish[0],
            size: source.size,
            frame: source.frame || source.color || finish[1] || 'None',
            colorway: source.colorway || '',
            sizeLabel: this.gallery?.variants?.[option.value]?.find(view => view.role === 'product')?.caption?.split(' · ')[0] || source.size
          }
        })
        if (this.configVariants.some(variant => !variant.format || !variant.size)) return
        this.controls = [...this.querySelectorAll('[data-option-control]')]
        this.refreshControls(this.configVariants.find(variant => variant.id === this.select.value))
        this.controls.forEach((control, index) => control.addEventListener('change', () => {
          const previous = this.configVariants.find(variant => variant.id === this.select.value)
          let candidates = this.configVariants
          this.controls.forEach((field, position) => {
            const key = field.dataset.optionControl
            const requested = position <= index ? field.value : previous[key]
            let matches = candidates.filter(variant => variant[key] === requested)
            if (!matches.length) {
              const preferred = candidates.find(variant => variant.available && variant.frame === 'Brown') || candidates.find(variant => variant.available) || candidates[0]
              matches = candidates.filter(variant => variant[key] === preferred[key])
            }
            candidates = matches
          })
          const next = candidates.find(variant => variant.available) || candidates[0]
          this.select.value = next.id
          this.refreshControls(next)
          this.updateVariant(true)
        }))
        this.querySelector('[data-configurator]').hidden = false
        this.querySelector('[data-variant-fallback]').hidden = true
      }

      refreshControls(selected) {
        let candidates = this.configVariants
        this.controls.forEach(control => {
          const key = control.dataset.optionControl
          const values = [...new Set(candidates.map(variant => variant[key]))]
          control.replaceChildren(...values.map(value => {
            const option = document.createElement('option')
            option.value = value
            option.textContent = key === 'size' ? candidates.find(variant => variant.size === value).sizeLabel : value
            option.selected = value === selected[key]
            return option
          }))
          control.closest('[data-configurator-field]').hidden = values.length === 1 && (key === 'colorway' || key === 'frame')
          candidates = candidates.filter(variant => variant[key] === selected[key])
        })
      }

      updateVariant(updateUrl) {
        const option = this.select?.selectedOptions[0]
        this.views = this.gallery?.variants?.[option?.value] || this.fallback
        if (option) {
          const available = option.dataset.available === 'true'
          this.price.textContent = option.dataset.price
          this.compare.textContent = option.dataset.compare
          this.compare.hidden = option.dataset.onSale !== 'true'
          this.addButton.disabled = !available
          this.addButton.textContent = available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldLabel
          if (updateUrl) {
            const url = new URL(window.location.href)
            url.searchParams.set('variant', option.value)
            window.history.replaceState({}, '', url)
          }
        }
        this.thumbnails.forEach((button, index) => {
          const view = this.views[index]
          button.hidden = !view
          if (!view) return
          const image = button.querySelector('img')
          image.removeAttribute('srcset')
          image.src = this.imageUrl(view, 240)
          image.alt = ''
          button.title = view.caption || view.alt || ''
        })
        const activeViewIndex = this.activeViewRole ? this.views.findIndex(view => view.role === this.activeViewRole) : -1
        const fallbackIndex = this.gallery ? 0 : this.views.findIndex(view => String(view.media_id) === option?.dataset.mediaId)
        this.showView(activeViewIndex >= 0 ? activeViewIndex : Math.max(0, fallbackIndex))
      }

      showView(index) {
        const view = this.views[index]
        if (!view || this.image?.tagName !== 'IMG') return
        this.activeViewRole = view.role
        this.stage.dataset.productPreview = String(view.role === 'product' && view.width > 0 && view.width === view.height)
        const widths = [...new Set([400, 600, 800, 1200, 1600, 2000].map(width => Math.min(width, view.width || width)))]
        this.image.srcset = widths.map(width => `${this.imageUrl(view, width)} ${width}w`).join(', ')
        this.image.src = this.imageUrl(view, 2000)
        this.image.alt = view.alt || ''
        this.image.width = view.width || 1600
        this.image.height = view.height || 1600
        this.querySelector('product-magnifier').dataset.zoomSource = view.role === 'product' ? this.imageUrl(view, 2000) : ''
        this.caption.textContent = view.caption || ''
        this.thumbnails.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)))
      }
    })
  }

  } catch(e) { console.error(e); }
})();
})();
